import {AGENCY_PROFILE} from './../actions/ActionTypes';
import InitialState from './InitialState';

const AgencyProfileReducer = (state = InitialState.manageUser, action) => {
    switch (action.type) {
        case AGENCY_PROFILE: {
            let data = Object.assign({}, state);

            data.payPeriod =  action.payPeriod;
            data.agencyType = action.agencyType;
            data.agency = action.agency;
            data.premiumRange = action.premiumRange; 
            data.managementSystem = action.managementSystem;
            data.states = action.states; 
            data.timezones = action.timezones;

            return data;
        }

        default:
            return state;
    }
};
export default AgencyProfileReducer;



// WEBPACK FOOTER //
// ./src/reducers/AgencyProfileReducer.js